<script>
  // import {Bar} from 'vue-chartjs'
  import {VueCharts,mixins} from 'vue-chartjs'
  export default {
    extends: VueCharts.Bar,
    mixins: [ mixins.reactiveProp ],
    props: {
      chartData: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },

    mounted() {
      this.renderChart(this.chartData, this.options);
    },
  }
</script>
